export default `
    <div class="fly-up-input-container #=data.bsc||""#">
        <div class="fly-up-label bold bind-label" data-bind="text: #= data.title #">
        </div>
        <div class="fly-up-input">
            <span class="fly-up-input-image #= data.imageClass #">
            </span>
            <input class="fly-up-placeholder" autocomplete='no!' # if (data.required) { # required # } # # if (data.disabled) { # disabled # } # #= data.autoFocus # id="#= data.id #" name="#= data.name #"
                 type="#= data.inputType #" placeholder="#= data.placeholder #"
            />
        </div>
        #= data.components #
    </div>
`;
